import { defineMessages } from 'react-intl';

export default defineMessages({
    insuranceHistoryTitle: {
        id: 'wmic-pe-capability-gateway-policychange-pa-react.pages.InsuranceHistory.WMICPCPAInsuranceHistoryPage.Title',
        defaultMessage: 'Insurance History',
    },
});
